export const SET_USER_DETAIL = 'SET_USER_DETAIL';

export function setUser(userDetail) {
  return {
    type: SET_USER_DETAIL,
    userDetail,
  };
}
